// @flow
import type { Periodicity } from 'digicel-kaizen-library';
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import config from '../../../config';
import formatPeriodicity from '../../../lib/TripicaPeriodicityFormatter';
import FormatService from '../../../lib/format';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';

function getStyles() {
  return StyleSheet.create({
    container: {
      marginTop: 20,
      justifyContent: 'center',
      backgroundColor: 'white',
    },
    summaryContainer: {
      paddingHorizontal: 20,
      paddingVertical: 2,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: 'white',
    },
    messageContainer: {
      paddingHorizontal: 20,
      backgroundColor: 'white',
    },
    label: {
      fontSize: 18,
      color: theme.primaryColor,
    },
    priceContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    totalPrice: {
      fontSize: 18,
      fontWeight: '500',
      color: theme.primaryColor,
    },
    periodicity: {
      fontSize: 14,
      color: theme.primaryColor,
    },
    message: {
      fontSize: 14,
      color: theme.secondaryColor,
    },
    tax: {
      paddingHorizontal: 20,
      fontSize: 12,
      fontStyle: 'italic',
      color: theme.secondaryColor,
      marginTop: 4,
    },
  });
}

const showTaxDescriptionLabel = isExemptedFromTax => {
  if (config.displayPricesShownAreExclusiveOfTaxMessage && typeof isExemptedFromTax === 'boolean') {
    return !isExemptedFromTax;
  }

  return false;
};

const OrderSummary = (props: Props) => {
  const styles = getStyles();
  return (
    <View style={styles.container}>
      <View style={styles.summaryContainer}>
        <Text style={styles.label}>{props.label} :</Text>
        <View style={styles.priceContainer}>
          <Text style={styles.totalPrice}>{FormatService.formatCentsToCurrency(props.totalPrice, true)}</Text>
          {props.periodicity && <Text style={styles.periodicity}>{formatPeriodicity(props.periodicity)}</Text>}
        </View>
      </View>
      {props.message ? (
        <View style={styles.messageContainer}>
          <Text style={styles.message}>{props.message}</Text>
        </View>
      ) : null}
      {showTaxDescriptionLabel(props.isExemptedFromTax) && (
        <Text style={styles.tax}>{I18n.t('tax.inclusiveDescription')}</Text>
      )}
    </View>
  );
};

type Props = {
  label: string,
  totalPrice: number,
  periodicity?: Periodicity,
  message?: ?string,
  isExemptedFromTax?: boolean,
};

export default OrderSummary;
